import { render, staticRenderFns } from "./DeleteModal.vue?vue&type=template&id=a6cba2d8&"
import script from "./DeleteModal.vue?vue&type=script&lang=js&"
export * from "./DeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6cba2d8')) {
      api.createRecord('a6cba2d8', component.options)
    } else {
      api.reload('a6cba2d8', component.options)
    }
    module.hot.accept("./DeleteModal.vue?vue&type=template&id=a6cba2d8&", function () {
      api.rerender('a6cba2d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/staffCalendar/DeleteModal.vue"
export default component.exports